import {
  ArnValidAuthConfig,
  ArnValidTrackingConfig,
  ArnValidConditionConfig,
  ArnValidDataConfig,
  ArnValidI18nConfig,
  ArnValidNftConfig,
  ArnValidLogConfig,
} from '@arianee/arn-types';
import { ArnClientConfigImpl } from './ArnClientConfigImpl';
import { ArnValidHttpClientConfig } from './ArnHttpClientConfig';

export class ArnHttpClientConfigImpl
  extends ArnClientConfigImpl
  implements ArnValidHttpClientConfig
{
  constructor(
    readonly serverUrl: string,
    /**
     * URL of the ARN Server to connect to.
     * This will typically include the project's api key.
     */
    track: ArnValidTrackingConfig,
    i18n: ArnValidI18nConfig,
    auth: ArnValidAuthConfig,
    nft: ArnValidNftConfig,
    data: ArnValidDataConfig,
    condition: ArnValidConditionConfig,
    log: ArnValidLogConfig,
    autoRegister: boolean
  ) {
    super(track, i18n, auth, nft, data, condition, log, autoRegister);
  }
}
